import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LeadersContext = createContext({ leaders: null, refresh: () => {} });

export function LeadersProvider({ children }) {
  const { user } = useAuth();
  const [leaders, setLeaders] = useState(null);

  const refresh = useCallback(() => {
    api.get("/leaders").then((r) => setLeaders(r.data)).catch(() => setLeaders(null));
  }, []);

  useEffect(() => {
    if (!user) { setLeaders(null); return; }
    refresh();
    const t = setInterval(refresh, 5 * 60 * 1000); // 5 min
    return () => clearInterval(t);
  }, [user, refresh]);

  return (
    <LeadersContext.Provider value={{ leaders, refresh }}>{children}</LeadersContext.Provider>
  );
}

export function useLeaders() {
  return useContext(LeadersContext);
}
